import * as yup from "yup";

export const requiredString = yup.string().required("Required");

export const emailSchema = requiredString.email("Invalid email format!");
